import "./sidebar.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContex";
import { useContext } from "react";
import MarketOverview from "../tradingview/Marketoverview";
export default function Sidebar() {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PS = process.env.REACT_APP_PUBLIC_SERVER;

  const { user } = useContext(AuthContext);

  console.log(user.imagemProfil);

  return (
    <>
      <div className="col-xxl-3 col-lg-3 col-md-3 scroll">
        <div className="card">
          <div className="card-body">
            <div className="dropdown float-end">
              <a
                href="#"
                className="dropdown-toggle arrow-none card-drop"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="mdi mdi-dots-horizontal"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                <a href="javascript:void(0);" className="dropdown-item">
                  Edit Profile
                </a>

                <a href="javascript:void(0);" className="dropdown-item">
                  Settings
                </a>
              </div>
            </div>

            <Link to={`perfil/${user.username}`}>
              <div className="d-flex align-self-start">
                <img
                  className="d-flex align-self-start rounded me-2"
                  src={
                    user.imagemProfil
                      ? PS + "users/" + user.imagemProfil
                      : PS + "users/noavatar.jpg"
                  }
                  alt="Dominic Keller"
                  height="48"
                />
                <div className="w-100 overflow-hidden">
                  <h5 className="mt-1 mb-0">{user.username}</h5>
                  <p className="mb-1 mt-1 text-muted">
                    {user.morada ? user.morada : "Sem Morada"}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
